var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pb-0 pt-0 ",staticStyle:{"background-color":"#f8f9f9"},attrs:{"align":"center"}},[_c('v-col',{attrs:{"align":_vm.align}},[_c('h1',{staticClass:"Black  "},[_vm._t("default")],2),_c('hr',{staticClass:"text-left"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }